import { List, Map } from 'immutable'
import { FirebaseList } from '../firebase'
import * as housingResultActions from './actions'
import { HousingResult } from './housing-result'

class HousingResultList extends FirebaseList {
  unwrapSnapshot(snapshot) {
    let attrs = snapshot.val()
    let newHousingResult = {
      assignment: new Map(attrs.assignment),
      confirmedGroupId: attrs.confirmedGroupId,
      email: attrs.email,
      key: snapshot.key,
      index: attrs.index,
      lottery: attrs.lottery
    }

    return new this._modelClass(newHousingResult)
  }
}

export const housingResultList = new HousingResultList({
  onAdd: housingResultActions.createHousingResultSuccess,
  onChange: housingResultActions.updateHousingResultSuccess,
  onLoad: housingResultActions.loadHousingResultsSuccess,
  onRemove: housingResultActions.deleteHousingResultSuccess
}, HousingResult)


// WEBPACK FOOTER //
// ./src/core/housing-result/housing-result-list.js